import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var mapValidResultsToFieldInternalShape = function mapValidResultsToFieldInternalShape(results) {
  return results.reduce(function (acc, result) {
    if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) {
      acc.data = _objectSpread(_objectSpread({}, acc.data), result.data);
    }
    return acc;
  }, {
    isValid: true,
    data: {}
  });
};
export var filterInvalidResults = function filterInvalidResults(validationResults) {
  return validationResults.reduce(function (acc, result) {
    if (result.isValid === false) {
      acc.push(result);
    }
    return acc;
  }, []);
};